import { render, staticRenderFns } from "./SalesStatusIcon.vue?vue&type=template&id=2322863d&scoped=true&"
import script from "./SalesStatusIcon.vue?vue&type=script&lang=js&"
export * from "./SalesStatusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2322863d",
  null
  
)

export default component.exports